// AluRightDoor.js

import React, { useEffect, useRef, useState } from 'react';
import { useFrame } from '@react-three/fiber';
import { Vector3 } from 'three';
import { useFormStore } from '../../state/FormStore';

export function AluRightDoor({ verandaSize, verandaColor, opaalTexture, playTexture, verandaEndPosition, nodes, vnodes, materials, handleSlide }) {
    const [isOpen, setIsOpen] = useState(false);
    const slidingDoorRightRef = useRef();
    const slidingDoorLeftRef = useRef();

    const doorSize = verandaSize[2]; // Uitval
    let TwoDoorPositionL = [0, 0, 0];
    let TwoDoorPositionR = [0, 0, 0];
    let TwoDoorScale = [1, 1, 1];
    let isTwoDoor = false;
    const formData = useFormStore(state => state.formData.rechter.rechter_wand_option);
    //    handleSlide = 'Rechts';
    if (doorSize < 1.336) {
        TwoDoorPositionL = [0, 0, -0.21];
        TwoDoorPositionR = [0, 0, 0.225];
        TwoDoorScale = [1, 1, 2];
        isTwoDoor = true;
    }

    const handleDoorClick = () => {
        setIsOpen(!isOpen);
    };

    useFrame((state, delta) => {
        const openPositionRight = new Vector3(0, 0, 0.1); // Adjust the value to fit the animation distance
        const closePositionRight = new Vector3(0, 0, 0);
        const openPositionLeft = new Vector3(0, 0, -0.1); // Adjust the value to fit the animation distance
        const closePositionLeft = new Vector3(0, 0, 0);

        const targetPositionRight = isOpen ? openPositionRight : closePositionRight;
        const targetPositionLeft = isOpen ? openPositionLeft : closePositionLeft;

        if (slidingDoorRightRef.current) {
            slidingDoorRightRef.current.position.lerp(targetPositionRight, delta * 5); // Adjust the speed multiplier as needed
        }
        if (slidingDoorLeftRef.current) {
            slidingDoorLeftRef.current.position.lerp(targetPositionLeft, delta * 5); // Adjust the speed multiplier as needed
        }
    });

    useEffect(() => {
        if (formData) {
            setIsOpen(true); // Open the door when formData changes
            const timeout = setTimeout(() => {
                setIsOpen(false); // Close the door after a brief delay
            }, 1000); // Adjust the delay as needed

            return () => clearTimeout(timeout);
        }
    }, [formData]); // Re-run when formData changes


    return (
        <group name="left_alum_door" scale={verandaSize} position={[0, 0, 0]}>
            <mesh
                castShadow
                receiveShadow
                onClick={handleDoorClick}
                geometry={vnodes.geometry}>
                <meshStandardMaterial attach="material" map={playTexture} transparent opacity={1} />
            </mesh>

            <mesh
                castShadow
                receiveShadow
                geometry={nodes.Alu_Rail002.geometry}
                material={materials.silver_dull}
                handleSlide={'Richts'}
            >
                <meshStandardMaterial attach="material" color={verandaColor[0]} />
            </mesh>
            {((isTwoDoor && handleSlide === "Links") || !isTwoDoor) && (
                <group className="2_alum_door_left" scale={TwoDoorScale} position={TwoDoorPositionL}>
                    <group className="fix_door_right">
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes.alu_fix_l002_1.geometry}
                        >
                            <meshStandardMaterial attach="material" color={verandaColor[0]} />
                        </mesh>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes.alu_fix_l002_2.geometry}
                        >
                            <meshStandardMaterial attach="material" map={opaalTexture} color={"#ccc"} transparent opacity={0.2} />
                        </mesh>
                    </group>
                    <group className="slide_door_right" ref={slidingDoorRightRef} onClick={handleDoorClick}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes.alu_slide_l002.geometry}
                        >
                            <meshStandardMaterial attach="material" color={verandaColor[0]} />
                        </mesh>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes.alu_slide_l002_1.geometry}
                        >
                            <meshStandardMaterial attach="material" color={verandaColor[0]} />
                        </mesh>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes.alu_slide_l002_2.geometry}
                        >
                            <meshStandardMaterial attach="material" map={opaalTexture} color={"#ccc"} transparent opacity={0.2} />
                        </mesh>
                        <group>
                            <mesh
                                castShadow
                                receiveShadow
                                geometry={nodes['handel_front-L002'].geometry}
                                material={materials.silver_dull}
                            />
                            <mesh
                                castShadow
                                receiveShadow
                                geometry={nodes['handel_Back-L002'].geometry}
                                material={materials.silver_dull}
                            />
                            <mesh
                                castShadow
                                receiveShadow
                                geometry={nodes.keyhole_circle002.geometry}
                                material={nodes.keyhole_circle002.material}
                            />
                            <mesh
                                castShadow
                                receiveShadow
                                geometry={nodes.Keyhole002.geometry}
                                material={nodes.Keyhole002.material}
                            />
                        </group>
                    </group>
                </group>
            )}
            {((isTwoDoor && handleSlide === "Rechts") || !isTwoDoor) && (
                <group className="2_alum_door_right" scale={TwoDoorScale} position={TwoDoorPositionR} >
                    <group className="slide_door_left" ref={slidingDoorLeftRef} onClick={handleDoorClick}>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes.alu_slide_r002.geometry}
                            material={materials['lambert3.002']}
                        />
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes.alu_slide_r002_1.geometry}
                        >
                            <meshStandardMaterial attach="material" color={verandaColor[0]} />
                        </mesh>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes.alu_slide_r002_2.geometry}
                        >
                            <meshStandardMaterial attach="material" map={opaalTexture} color={"#ccc"} transparent opacity={0.2} />
                        </mesh>
                        <group>
                            <mesh
                                castShadow
                                receiveShadow
                                geometry={nodes['handel_front-R002'].geometry}
                                material={materials.silver_dull}
                            />
                            <mesh
                                castShadow
                                receiveShadow
                                geometry={nodes['handel_Back-R002'].geometry}
                                material={materials.silver_dull}
                            />
                        </group>
                    </group>
                    <group className="fix_door_left">
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes.alu_fix_r002_1.geometry}
                        >
                            <meshStandardMaterial attach="material" color={verandaColor[0]} />
                        </mesh>
                        <mesh
                            castShadow
                            receiveShadow
                            geometry={nodes.alu_fix_r002_2.geometry}
                        >
                            <meshStandardMaterial attach="material" map={opaalTexture} color={"#ccc"} transparent opacity={0.2} />
                        </mesh>
                    </group>
                </group>
            )}
        </group>
    );

}

//useGLTF.preload('/veranda3/AluminiumDoor.glb');
